import { DialogContent, Grid, Divider, Button, Dialog, IconButton } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { OPEN_BACKDROP, DESTROY_BACKDROP } from "../../../../containers/actions/types";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography, CircularProgress } from "@material-ui/core";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from "@material-ui/lab";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import moment from "moment";
import axios from 'axios';
import { appUrl } from '../../../../../../utils/config';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import EditIcon from '@material-ui/icons/Edit';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { presentFormatedData } from "../../functionalComponents/dataFormatFunctions";
import StructuredInformationFiles from "./updateBatch/StructuredInformation/StructuredInformationFiles";
import StructuredInformation from "./updateBatch/StructuredInformation/StructuredInformation";
import ProductDetailsLoader from "./ProductDetailsLoader";
import EditPlannedAllocatedQuantityDialog from '../../PurchaseOrderDashbaordIndex/POColumns/EditPlannedAllocatedQuantityDialog';
import StyledDialog from '../../../../../../components/common/models/Dialog';

const useStyles = makeStyles((theme) => ({
  timelineContainer: {
    padding: 0, // Remove padding
    margin: 0, // Remove margin
  },
  timeline: {
    paddingLeft: 0, // Remove padding to eliminate left space
  },
  timelineItem: {
    "&.MuiTimelineItem-missingOppositeContent:before": {
      display: "none", // This removes the default ::before content
    },
  },
  timelineDot: {
    backgroundColor: "#1391C9",
    width: "30px",
    height: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    fontSize: "1.2rem",
    fontWeight: "bold",
    fontFamily: "Inter",
  },
  timelineDotText: {
    fontFamily: theme.typography.fontFamily,
  },
  timelineContentBox: {
    padding: theme.spacing(1),
    // border: '1px solid #ddd',
    borderRadius: "8px",
    // backgroundColor: '#f9f9f9',
    marginBottom: theme.spacing(4),
  },
  stepTitle: {
    fontWeight: "600",
    fontSize: "20px",
  },
  separator: {
    backgroundColor: "#1391C9",
    width: "4px",
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  root: {
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    // width: '100%',
    // backgroundColor: '#EDEDED',
    "& .MuiStepLabel-label": {
      color: "rgba(0, 0, 0, 0.87)",
      fontWeight: 500,
    },
  },
  table: {
    minWidth: 650,
  },
  tableContainer: {
    boxShadow: "none", // Remove border and shadow from the container
    // marginBottom: '3rem',
  },
  tableCell: {
    textAlign: "left",
    backgroundColor: "#E5F2F7",
    borderBottom: "none", // Remove bottom border
    // width: '16.666%', // Set equal width for each cell
    padding: "16px", // Standard padding for consistency
  },
  tableCell2: {
    textAlign: "left",
    backgroundColor: "#E5F2F7",
    borderBottom: "none", // Remove bottom border
    // width: '16.666%', // Set equal width for each cell
    padding: "16px", // Standard padding for consistency
    paddingTop: "0px",
  },
  headerCell: {
    fontWeight: "bold",
  },
  editIconButton: {
    "&.Mui-disabled": {
      "& svg": {
        color: "#ec6535 !important",
        opacity: 0.4,
      },
    },
  },
}));

const ViewStructuredInformation = (props) => {
  const { batchDetails, schrockenDeliveryScheduleID, targetQuantity, cmoBatchNumber, consumptionSameAsAllocation } = props;
  //console.log("consumptionSameAsAllocation",props.consumptionSameAsAllocation  )
  const classes = useStyles();
  const dispatch = useDispatch();
  const [digitizedExtractedData, setDigitizedExtractedData] = useState([]);
  const [loadingDigitizedData, setLoadingDigitizedData] = useState(false);
  const [digitizedDataError, setDigitizedDataError] = useState(null);

  const [showConsumptionDialog, setShowConsumptionDialog] = useState(false);
  const [allocationData, setAllocationData] = useState([]);
  const [allocationLoading, setAllocationLoading] = useState(false);
  const [allocationError, setAllocationError] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedRowForEdit, setSelectedRowForEdit] = useState(null);
  const [allocationRes, setAllocationRes] = useState({});
  const [poLineRes, setPoLineRes] = useState({});
  const [actionForConsumption, setActionForConsumption] = useState(false);
  const [consumptionUpdateLoading, setConsumptionUpdateLoading] = useState(false);
  const [consumptionUpdateSuccess, setConsumptionUpdateSuccess] = useState(false);
  const [componentAllocationSuccess, setComponentAllocationSuccess] = useState(false);
  const [depleteInstructionComponents, setDepleteInstructionComponents] = useState([]);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);

  const showConsumptionStep =props.consumptionSameAsAllocation===true;


  const { existingCOAFiles, existingCustomFiles, existingEInvoiceFiles, existingEWayBillFiles, customFilesList } = batchDetails;

  const allFiles = [
    ...(existingCOAFiles?.length ? existingCOAFiles : []),
    ...(existingCustomFiles?.length ? existingCustomFiles : []),
    ...(existingEInvoiceFiles?.length ? existingEInvoiceFiles : []),
    ...(existingEWayBillFiles?.length ? existingEWayBillFiles : []),
    ...(customFilesList?.length ? customFilesList : []),
  ];


  // Preserve original file types for backward compatibility
  // const fileTypeOrder = [
  //   "BMR",
  //   "COC",
  //   "dsbatch_coa",
  //   "packingList",
  //   "PackingList",
  //   "proformaInvoice",
  //   "eInvoice",
  //   "CommercialInvoice",
  //   "DeliveryNote",
  //   "ConfirmationOfPartialManufacturingOfAnMedicinalProduct",
  //   "FinishedProductDispatchCheckList",
  //   // New digitized document types
  //   "ConsumptionDetails",
  //   "BillOfLading",
  //   "PackingSlip",
  //   "CertificateOfAnalysis",
  //   "CertificateOfManufacture"
  // ];

  // const sortedFiles = allFiles?.sort((a, b) => {
  //   return fileTypeOrder.indexOf(a.customFileType) - fileTypeOrder.indexOf(b.customFileType);
  // });

  // const getLatestFiles = (files) => {
  //   const fileMap = new Map();

  //   files.forEach(file => {
  //     const key = `${file.customFileType}-${file.customFileName}`;
  //     const existing = fileMap.get(key);

  //     if (!existing || new Date(file.lastUpdatedDate) > new Date(existing.lastUpdatedDate)) {
  //       fileMap.set(key, file);
  //     }
  //   });

  //   return Array.from(fileMap.values());
  // };


  // // Process existing files (preserve original logic)
  // const doubleSortedFiles = getLatestFiles(
  //   sortedFiles.filter(file => file?.customFileType !== "custom")
  // );

  useEffect(() => {
    const extractDigitizedDataFromBatchDetails = () => {
      try {
        setLoadingDigitizedData(true);
        setDigitizedDataError(null);

        const extractedDocuments = [];

        // Create a map of digitized extracted data for matching structured data
        const digitizedDataMap = new Map();
        if (batchDetails.digitizedExtractedData && Array.isArray(batchDetails.digitizedExtractedData)) {
          batchDetails.digitizedExtractedData.forEach(item => {
            const documentType = item.kvpJsonOriginal?.document_type;
            if (documentType) {
              digitizedDataMap.set(documentType, item);
            }
          });
        }

        // Process documents from customFilesList
        if (batchDetails.customFilesList && Array.isArray(batchDetails.customFilesList)) {
          batchDetails.customFilesList.forEach(doc => {
            // Find matching structured data from digitizedExtractedData
            const structuredData = digitizedDataMap.get(doc.customFileType);
            
            // Create kvpJson from the structured data
            let kvpJson = null;
            if (structuredData && structuredData.kvpJsonOriginal) {
              kvpJson = JSON.stringify(structuredData.kvpJsonOriginal);
            }

            // Transform the document to match the expected structure
            const transformedDoc = {
              documentType: doc.customFileType,
              processedFileName: doc.customFileName,
              schrockenCustomFileID: doc.schrockenCustomFileID,
              emailReceivedTimestamp: doc.lastUpdatedDate,
              status: 'completed',
              customFileHash: doc.customFileHash,
              customFileDescription: doc.customFileDescription,
              markedForDelete: doc.markedForDelete,
              kvpJson: kvpJson,
              originalDigitizedData: structuredData // Keep reference to original structured data
            };
            extractedDocuments.push(transformedDoc);
          });
        }

        // Sort by lastUpdatedDate in ascending order
        extractedDocuments.sort((a, b) => {
          const dateA = new Date(a.emailReceivedTimestamp);
          const dateB = new Date(b.emailReceivedTimestamp);
          return dateA - dateB;
        });

        setDigitizedExtractedData(extractedDocuments);
        
        
      } catch (error) {
        console.error('Error extracting digitized data from batch details:', error);
        setDigitizedDataError(error.message);
        setDigitizedExtractedData([]);
      } finally {
        setLoadingDigitizedData(false);
      }
    };

    if (batchDetails) {
      extractDigitizedDataFromBatchDetails();
    }
  }, [batchDetails]);

  const fetchAllocationData = async () => {
    const batchID = batchDetails?.schrockenDeliveryScheduleBatchID;
    const batchSize = batchDetails?.batchSize;
    if (!batchID || !batchSize) return null;
    setAllocationLoading(true);
    setAllocationError(null);
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchComponentAllocationPlannedAndActualNew/${batchID}/${batchSize}`;
      const res = await axios.get(url);
      if (res.data?.status) {
        const list = res.data.data?.length > 0 ? res.data.data : [];
        setAllocationData(list);
        setAllocationRes(res.data);

        // Compute deplete instruction components
        const depleteComponents = [];
        list.forEach((component) => {
          const lots = component?.plannedLotNumberAllocationDetails || [];
          const depleteLots = lots.filter(lot => lot?.isDepletedBatch === true);
          if (depleteLots.length > 0) {
            const batches = depleteLots.map(lot => lot?.lotNumber).filter(Boolean);
            if (batches.length > 0) {
              depleteComponents.push({
                componentCode: component?.componentCode,
                componentName: component?.componentName,
                batches,
              });
            }
          }
        });
        setDepleteInstructionComponents(depleteComponents);

        return list;
      } else {
        setAllocationData([]);
        setAllocationError('Failed to load allocation data');
        return null;
      }
    } catch (err) {
      console.error('Error fetching allocation data:', err);
      setAllocationError('Error loading allocation data');
      return null;
    } finally {
      setAllocationLoading(false);
    }
  };

  const fetchPoLineData = async () => {
    const schrockenSLID = batchDetails?.schrockenSLID;
    if (!schrockenSLID) return;
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchComponentAllocationForPOLineNew/${schrockenSLID}`;
      const res = await axios.get(url);
      if (res.data?.status) {
        setPoLineRes(res.data.data);
      }
    } catch (err) {
      console.error('Error fetching PO line data:', err);
    }
  };

  const handlePencilClick = (row) => {
    setActionForConsumption(false);
    const list = poLineRes?.componentAllocationDataList || [];
    const match = list.find(
      c => c?.componentAllocationDetails?.componentCode === row.componentCode
    ) || list[0] || null;
    setSelectedRowForEdit(match);
    setEditDialogOpen(true);
  };

  const handleUpdateConsumption = async () => {
    setConsumptionUpdateLoading(true);
    dispatch({ type: OPEN_BACKDROP, payload: 'Please wait' });
    try {
      const BOMConsumptionDetails = allocationData.map(component => ({
        BomComponentCode: component.componentCode,
        bomComponentCodeCMO: component.componentCode,
        BomComponentName: component.componentName,
        BomComponentRefUOM: component.uom,
        bomComponentRefUOMCMO: component.uom,
        consumptionBatchNumbers: (component.plannedLotNumberAllocationDetails || []).map(lot => ({
          componentBatchNumber: lot.lotNumber,
          componentBatchNumberCMO: lot.lotNumber,
          BomComponentConsumedQuantity: lot.plannedAllocatedQuantity,
          bomComponentConsumedQuantityCMO: lot.plannedAllocatedQuantity,
        })),
      }));
      const payload = {
        vendorMosymphonyID: batchDetails?.vendorMosymphonyID,
        BOMConsumptionDataList: [{
          scheduleAgreementNumber: batchDetails?.scheduleAgreementNumber || '',
          schrockenSLID: batchDetails?.schrockenSLID,
          schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID,
          BOMConsumptionDetails,
        }],
      };
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateBOMConsumedQty`;
      const res = await axios.post(url, payload);
      if (res.data?.status) {
        setConsumptionUpdateSuccess(true);
        setActionForConsumption(false);
      }
    } catch (err) {
      console.error('Error updating consumption:', err);
    } finally {
      setConsumptionUpdateLoading(false);
      dispatch({ type: DESTROY_BACKDROP });
    }
  };

  // Improved filtering logic - process only digitized documents from customFilesList
  // const existingFileTypes = new Set(doubleSortedFiles.map(file => file.customFileType));
  
  // Helper function to match digitized data: first by document_type, then by schrockenCustomFileID
  const findMatchingDigitizedData = (file) => {
    if (!Array.isArray(batchDetails.digitizedExtractedData)) return null;
    
    // Step 1: Find all items matching document_type
    const typeMatches = batchDetails.digitizedExtractedData.filter(
      item => item.kvpJsonOriginal?.document_type === file.customFileType
    );
    
    if (typeMatches.length === 0) return null;
    
    // Step 2: Check if any match by schrockenCustomFileID (exact match)
    const idMatch = typeMatches.find(
      item => item.schrockenCustomFileID === file.schrockenCustomFileID || 
              item.schrockenCustomFileID?.toString() === file.schrockenCustomFileID?.toString()
    );
    
    // Return exact ID match if found, otherwise null (we only want exact matches)
    return idMatch || null;
  };

  // Process digitized documents with improved logic
  // Process all files from allFiles
const digitizedDocuments = allFiles
  .map(file => {
    // Find matching structured data using helper function (exact match by document_type AND schrockenCustomFileID)
    const structuredData = findMatchingDigitizedData(file);
    
    // Check if it's an exact match (by ID)
    const isExactMatch = structuredData !== null;

    // Create kvpJson from the structured data
    let kvpJson = null;
    if (structuredData && structuredData.kvpJsonOriginal) {
      kvpJson = JSON.stringify(structuredData.kvpJsonOriginal);
    }

    return {
      documentType: file.customFileType,
      processedFileName: file.customFileName,
      schrockenCustomFileID: file.schrockenCustomFileID,
      emailReceivedTimestamp: file.lastUpdatedDate,
      status: 'completed',
      customFileHash: file.customFileHash,
      customFileDescription: file.customFileDescription,
      markedForDelete: file.markedForDelete,
      kvpJson: kvpJson,
      originalDigitizedData: structuredData,
      customFileType: file.customFileType,
      customFileName: file.customFileName,
      lastUpdatedDate: file.lastUpdatedDate,
      isDigitized: !!structuredData, // Mark as digitized if structured data exists
      isExactMatch: isExactMatch, // Track if it's an exact match by schrockenCustomFileID
      isDuplicate: file.isDuplicate || false // Default to false if isDuplicate is undefined
    };
  })
  .filter(doc => doc.processedFileName && doc.processedFileName !== '');

  // Enhanced sorting logic: Returns both latest and replaced documents with proper matching
  const getOptimallyOrderedFiles = (documents) => {
    // Define the category order
    const categoryOrder = {
      'Post-Manufacturing': 1,
      'Pre-Shipment Documents': 2,
      'Post-Shipment Documents': 3
    };

    // Step 1: Group documents by type and track first occurrence
    const documentGroups = new Map();
    const firstOccurrence = new Map();

    documents.forEach(doc => {
      const docType = doc.customFileType;
      const docDate = new Date(doc.lastUpdatedDate || doc.emailReceivedTimestamp);
      
      // Track the first occurrence of each document type
      if (!firstOccurrence.has(docType)) {
        firstOccurrence.set(docType, docDate);
      } else {
        const existingFirstDate = firstOccurrence.get(docType);
        if (docDate < existingFirstDate) {
          firstOccurrence.set(docType, docDate);
        }
      }

      // Group documents by type
      if (!documentGroups.has(docType)) {
        documentGroups.set(docType, []);
      }
      documentGroups.get(docType).push(doc);
    });

    // Step 2: For each group, get the latest and replaced documents
    const latestDocuments = [];
    const replacedDocuments = [];
    
    documentGroups.forEach((docs, docType) => {
      // Sort documents in this group by date (latest first)
      const sortedDocs = docs.sort((a, b) => {
        const dateA = new Date(a.lastUpdatedDate || a.emailReceivedTimestamp);
        const dateB = new Date(b.lastUpdatedDate || b.emailReceivedTimestamp);
        return dateB - dateA; // Descending order: latest first
      });
      
      if (sortedDocs.length === 0) return;
      
      // Get category from the original file data
      const originalFile = allFiles.find(f => f.schrockenCustomFileID === sortedDocs[0].schrockenCustomFileID);
      const documentCategoryType = originalFile?.documentCategoryType || '';
      
      const latestDoc = sortedDocs[0];
      const latestHasMatch = latestDoc.isExactMatch === true;
      
      // Add latest document to main section
      latestDocuments.push({
        ...latestDoc,
        firstOccurrenceDate: firstOccurrence.get(docType),
        documentCategoryType: documentCategoryType
      });
      
      // Handle Replaced Documents section
      if (sortedDocs.length > 1) {
        // Get remaining documents (excluding the latest one)
        const remainingDocs = sortedDocs.slice(1);
        
        // Group remaining documents by customFileHash
        const hashGroups = new Map();
        remainingDocs.forEach(doc => {
          const fileHash = doc.customFileHash || 'no-hash';
          if (!hashGroups.has(fileHash)) {
            hashGroups.set(fileHash, []);
          }
          hashGroups.get(fileHash).push(doc);
        });
        
        if (!latestHasMatch) {
          // Case 1: Latest has NO match
          // For each hash group, check for matches first, then show last updated
          hashGroups.forEach((docsInHashGroup, fileHash) => {
            // Sort by date (latest first) within hash group
            const sortedByHash = docsInHashGroup.sort((a, b) => {
              const dateA = new Date(a.lastUpdatedDate || a.emailReceivedTimestamp);
              const dateB = new Date(b.lastUpdatedDate || b.emailReceivedTimestamp);
              return dateB - dateA;
            });
            
            // First check if any document in this hash group has a match
            let matchedDoc = null;
            for (let i = 0; i < sortedByHash.length; i++) {
              if (sortedByHash[i].isExactMatch === true) {
                matchedDoc = sortedByHash[i];
                break; // Found match, use it
              }
            }
            
            // If match found, show matched document with Download + Review
            // If no match, show last updated document from this hash group with only Download
            const docToShow = matchedDoc || sortedByHash[0];
            const docFile = allFiles.find(f => f.schrockenCustomFileID === docToShow.schrockenCustomFileID);
            const docCategoryType = docFile?.documentCategoryType || documentCategoryType;
            
            // If no match found, remove digitized data to show only Download
            const finalDoc = matchedDoc ? {
              ...docToShow,
              firstOccurrenceDate: firstOccurrence.get(docType),
              documentCategoryType: docCategoryType
            } : {
              ...docToShow,
              originalDigitizedData: null,
              isDigitized: false,
              isExactMatch: false, // Force no match to show only Download
              firstOccurrenceDate: firstOccurrence.get(docType),
              documentCategoryType: docCategoryType
            };
            
            replacedDocuments.push(finalDoc);
          });
        } else {
          // Case 2: Latest HAS match
          // For each hash group, show last updated document with only Download
          hashGroups.forEach((docsInHashGroup, fileHash) => {
            // Sort by date (latest first) within hash group
            const sortedByHash = docsInHashGroup.sort((a, b) => {
              const dateA = new Date(a.lastUpdatedDate || a.emailReceivedTimestamp);
              const dateB = new Date(b.lastUpdatedDate || b.emailReceivedTimestamp);
              return dateB - dateA;
            });
            
            // Show last updated document from this hash group with only Download
            const lastUpdatedDoc = sortedByHash[0];
            const docFile = allFiles.find(f => f.schrockenCustomFileID === lastUpdatedDoc.schrockenCustomFileID);
            const docCategoryType = docFile?.documentCategoryType || documentCategoryType;
            
            // Remove digitized data to show only Download
            const docWithoutDigitized = {
              ...lastUpdatedDoc,
              originalDigitizedData: null,
              isDigitized: false,
              isExactMatch: false, // Force no match to show only Download
              firstOccurrenceDate: firstOccurrence.get(docType),
              documentCategoryType: docCategoryType
            };
            
            replacedDocuments.push(docWithoutDigitized);
          });
        }
      }
    });

    // Step 3: Sort by category order first, then by first occurrence date within each category
    const sortFunction = (a, b) => {
      const categoryA = categoryOrder[a.documentCategoryType] || 999;
      const categoryB = categoryOrder[b.documentCategoryType] || 999;
      
      // First sort by category
      if (categoryA !== categoryB) {
        return categoryA - categoryB;
      }
      
      // Within same category, sort by first occurrence date (earliest first)
      return a.firstOccurrenceDate - b.firstOccurrenceDate;
    };

    return {
      latest: latestDocuments.sort(sortFunction),
      replaced: replacedDocuments.sort(sortFunction)
    };
  };

  const { latest: finalSortedFiles, replaced: replacedDocuments } = getOptimallyOrderedFiles(digitizedDocuments);

  // Helper function to get document display info
  const getDocumentDisplayInfo = (file) => {
    let documentCategory = "File";
    let updatedFileName = 'File';
    let updatedDigitizedName = 'File';
    
    // Helper function to get base document type (removes _Digitized suffix)
    const getBaseDocumentType = (fileType) => {
      return fileType?.replace('_Digitized', '') || fileType;
    };
    
    const baseFileType = getBaseDocumentType(file?.customFileType);
    
    switch (baseFileType) {
      case "BMR":
        documentCategory = "Consumption Pages";
        updatedFileName = 'Consumption Pages.PDF';
        updatedDigitizedName = 'Digitized Consumption Details';
        break;
      case "COC":
        documentCategory = "COC";
        updatedFileName = 'Certificate of Conformance.PDF';
        updatedDigitizedName = 'Digitized CoC';
        break;
      case "dsbatch_coa":
        documentCategory = "COA";
        updatedFileName = 'Certificate of Analysis.PDF';
        updatedDigitizedName = 'Digitized CoA';
        break;
      case "eInvoice":
        documentCategory = "Invoice";
        updatedFileName = 'Invoice.PDF';
        updatedDigitizedName = 'Digitized Invoice';
        break;
      case "packingList":
      case "PackingList":
        documentCategory = "Packing List";
        updatedFileName = 'Packing List.PDF';
        updatedDigitizedName = 'Digitized Packing List';
        break;
      case "proformaInvoice":
        documentCategory = "Proforma Invoice";
        updatedFileName = 'Proforma Invoice.PDF';
        updatedDigitizedName = 'Digitized Proforma Invoice';
        break;
      // New digitized document types
      case "ConsumptionDetails":
        documentCategory = "Consumption Details";
        updatedFileName = 'Consumption Details.PDF';
        updatedDigitizedName = 'Digitized Consumption Details';
        break;
      case "BillOfLading":
        documentCategory = "Bill of Lading";
        updatedFileName = 'Bill of Lading.PDF';
        updatedDigitizedName = 'Digitized Bill of Lading';
        break;
      case "PackingSlip":
        documentCategory = "Packing Slip";
        updatedFileName = 'Packing Slip.PDF';
        updatedDigitizedName = 'Digitized Packing Slip';
        break;
      case "CertificateOfAnalysis":
        documentCategory = "Certificate of Analysis";
        updatedFileName = 'Certificate of Analysis.PDF';
        updatedDigitizedName = 'Digitized Certificate of Analysis';
        break;
      case "CertificateOfManufacture":
        documentCategory = "Certificate of Manufacture";
        updatedFileName = 'Certificate of Manufacture.PDF';
        updatedDigitizedName = 'Digitized Certificate of Manufacture';
        break;
      case "CommercialInvoice":
        documentCategory = "Commercial Invoice";
        updatedFileName = 'Commercial Invoice.PDF';
        updatedDigitizedName = 'Digitized Commercial Invoice';
        break;
      case "DeliveryNote":
        documentCategory = "Delivery Note";
        updatedFileName = 'Delivery Note.PDF';
        updatedDigitizedName = 'Digitized Delivery Note';
        break;
      case "ConfirmationOfPartialManufacturingOfAnMedicinalProduct":
        documentCategory = "Partial Manufacturing Confirmation";
        updatedFileName = 'Partial Manufacturing Confirmation.PDF';
        updatedDigitizedName = 'Digitized Partial Manufacturing Confirmation';
        break;
      case "FinishedProductDispatchCheckList":
        documentCategory = "Finished Product Dispatch Check List";
        updatedFileName = 'Finished Product Dispatch Check List.PDF';
        updatedDigitizedName = 'Digitized Finished Product Dispatch Check List';
        break;
      default:
        // Handle unknown document types - use the document type as the category
        if (file?.isDigitized && file?.originalDigitizedData?.documentType) {
          const originalType = file.originalDigitizedData.documentType;
          
          // Create human-readable names from document types
          documentCategory = originalType
            .replace(/([A-Z])/g, ' $1') // Add space before capital letters
            .trim() // Remove leading space
            .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
          
          // Force 'of' to lowercase wherever it appears
          const fixOf = (text) => text ? text.replace(/\bOf\b/g, 'of') : text;

          documentCategory = fixOf(documentCategory);
          updatedFileName = `${documentCategory}.PDF`;
          updatedDigitizedName = `Digitalized ${documentCategory}`;
        } else {
          // Apply the same humanize + 'of' lowercasing to baseFileType
          documentCategory = (baseFileType || "File")
            .replace(/([A-Z])/g, ' $1')
            .trim()
            .replace(/^./, str => str.toUpperCase());

          const fixOf = (text) => text ? text.replace(/\bOf\b/g, 'of') : text;

          documentCategory = fixOf(documentCategory);
          updatedFileName = `${documentCategory}.PDF`;
          updatedDigitizedName = `Digitalized ${documentCategory}`;
        }
        break;
    }
    
    return { documentCategory, updatedFileName, updatedDigitizedName };
  };

  // Helper function to render a document item
  const renderDocumentItem = (file, index, totalCount, isReplaced = false, stepOffset = 0) => {
    const { documentCategory, updatedFileName, updatedDigitizedName } = getDocumentDisplayInfo(file);
    // Only show digitized data if it's an exact match (by schrockenCustomFileID)
    const showDigitizedData = file.isExactMatch === true;

    return (
      <TimelineItem key={`${isReplaced ? 'replaced-' : ''}${index}`} className={classes.timelineItem}>
        <TimelineSeparator>
          <TimelineDot className={classes.timelineDot}>
            <span className={classes.timelineDotText}>{index + 1 + stepOffset}</span>
          </TimelineDot>
          {index !== totalCount - 1 &&
            <TimelineConnector className={classes.separator} />
          }
        </TimelineSeparator>
        <TimelineContent>
          <Box className={classes.timelineContentBox}>
            <Typography className={classes.stepTitle}>{documentCategory}</Typography>
            <StructuredInformation
              coa={true}
              batchDetails={batchDetails}
              cmoBatchNumber={cmoBatchNumber}
              structuredFiles={file}
              downloadFiles={file ? [file] : []}
              updatedFileName={updatedFileName}
              updatedDigitizedName={updatedDigitizedName}
              documentCategory={documentCategory}
              digitizedData={showDigitizedData ? file : null}
              isDuplicateDigitized={file.isDuplicate}
              poNumber={batchDetails?.scheduleAgreementNumber}
              batchNumber={batchDetails?.vendorBatchNumber}
              {...(updatedDigitizedName === 'Digitized Consumption Details' && { consumption: true })}
            />
          </Box>
        </TimelineContent>
      </TimelineItem>
    );
  };

  return (
    <React.Fragment>
      <DialogContent>
        {/* <Grid
          container
          justifyContent="flex-start"
          style={{ backgroundColor: "#c2e1ef" }}
        > */}
          {/* <Grid item>
            <TableContainer
              component={Paper}
              className={classes.tableContainer}
            >
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      PO Number
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Product Code / Description
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Plant ID
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Storage Location ID
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      CMO
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Batch Number
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.tableCell2}>
                      {presentFormatedData(
                        batchDetails?.scheduleAgreementNumber || "NA"
                      )}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {presentFormatedData(
                        `${batchDetails?.fgMaterialCode} / ${batchDetails?.fgMaterialName}` ||
                        "NA"
                      )}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {presentFormatedData(batchDetails?.vendorPlant || "NA")}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {presentFormatedData(
                        batchDetails?.storageLocation || "NA"
                      )}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {presentFormatedData(batchDetails?.cmoMember || "NA")}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {presentFormatedData(
                        batchDetails?.vendorBatchNumber || "NA"
                      )}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>  */}

           {/* Add ProductDetailsLoader component */}
        {/* {batchDetails?.collabrixProductID && ( */}
          <Grid style={{ marginTop: '1rem', marginBottom: '2rem' }}>
            <ProductDetailsLoader 
              collabrixProductID={batchDetails.collabrixProductID}
              poNumber={batchDetails?.scheduleAgreementNumber}
              materialPlantID={batchDetails?.vendorPlant}
              materialStorageLocationID={batchDetails?.storageLocation}
              batchNumber={batchDetails?.vendorBatchNumber}
              vendorMosymphonyID={batchDetails?.vendorMosymphonyID}
              vendorPlantID={batchDetails?.vendorPlant}
              sponsorStorageLocation={batchDetails?.storageLocation}
            />
          </Grid>
        {/* )} */}
        {/* </Grid> */}
      
        <Grid style={{ marginTop: '3rem' }}>
          {loadingDigitizedData && (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <CircularProgress />
              <Typography style={{ marginTop: '1rem' }}>Processing digitized documents...</Typography>
            </div>
          )}
          
          {digitizedDataError && (
            <div style={{ textAlign: 'center', padding: '1rem', backgroundColor: '#ffebee', borderRadius: '4px', marginBottom: '1rem' }}>
              <Typography color="error" variant="body2">
                Warning: Could not process digitized documents ({digitizedDataError})
              </Typography>
            </div>
          )}
          
          {digitizedDocuments.length === 0 && !loadingDigitizedData && (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <Typography>No digitized documents found.</Typography>
            </div>
          )}
          
          {/* Consumption Details Step — shown when consumptionSameAsAllocation and reviewAllocationForConsumptionReqd are both true */}
          {showConsumptionStep && (
            <TimelineItem className={classes.timelineItem}>
              <TimelineSeparator>
                <TimelineDot className={classes.timelineDot}>
                  <span className={classes.timelineDotText}>1</span>
                </TimelineDot>
                {finalSortedFiles.length > 0 && (
                  <TimelineConnector className={classes.separator} />
                )}
              </TimelineSeparator>
              <TimelineContent>
                <Box className={classes.timelineContentBox}>
                  <Typography className={classes.stepTitle}>Consumption Details</Typography>
                  <Typography variant="body2" style={{ margin: '0.5rem 0 1rem', color: '#000', fontWeight: 600, fontSize: '0.95rem' }}>
                    View/Edit Consumption Details
                  </Typography>
                  <Button
                    variant="contained"
                    style={{ backgroundColor: '#E65100', color: '#fff', textTransform: 'none', borderRadius: '24px', padding: '0.5rem 1.5rem', boxShadow: 'none' }}
                    onClick={() => { fetchAllocationData(); fetchPoLineData(); setShowConsumptionDialog(true); }}
                  >
                    View/Edit Consumption (same as allocation) Details
                  </Button>
                </Box>
              </TimelineContent>
            </TimelineItem>
          )}

          {/* Main Documents Section */}
          {finalSortedFiles.map((file, index) => renderDocumentItem(file, index, finalSortedFiles.length, false, showConsumptionStep ? 1 : 0))}
          
          {/* Replaced Documents Section */}
          {replacedDocuments.length > 0 && (
            <>
              <Grid style={{ marginTop: '3rem', marginBottom: '1rem' }}>
                {/* Top horizontal line with gap above */}
                <Divider style={{ marginTop: '1rem', marginBottom: '1rem' }} />
                {/* Replaced Documents title */}
                <Typography variant="h6" style={{ fontWeight: 600, color: '#000', marginBottom: '0.3rem' }}>
                  Replaced Documents
                </Typography>
                {/* Small line under title (like other sections) with gap below */}
                <span style={{ 
                  border: '2px solid #707070', 
                  display: 'block', 
                  width: '1.6rem', 
                  backgroundColor: '#707070',
                  marginBottom: '1.5rem'
                }}></span>
              </Grid>
              {replacedDocuments.map((file, index) => renderDocumentItem(file, index, replacedDocuments.length, true))}
            </>
          )}
        </Grid>
      </DialogContent>

      {/* Consumption Details Full-Screen Dialog */}
      <Dialog
        open={showConsumptionDialog}
        onClose={() => setShowConsumptionDialog(false)}
        fullScreen
      >
        {/* Header with Back button */}
        <div style={{ display: 'flex', alignItems: 'center', padding: '0.75rem 1.5rem', borderBottom: '1px solid #e0e0e0' }}>
          <Button
            startIcon={<ChevronLeftIcon />}
            onClick={() => setShowConsumptionDialog(false)}
            style={{ textTransform: 'none', color: '#000', fontWeight: 500, marginRight: '1rem', padding: 0, minWidth: 'auto' ,fontSize:15}}
          >
            Back
          </Button>
          <Typography variant="h6" style={{ fontWeight: 700 }}>
            View/Edit Consumption (same as alllocation) Details
          </Typography>
        </div>

        <DialogContent style={{ padding: '1.5rem' }}>
          {/* Batch header */}
          <ProductDetailsLoader
            collabrixProductID={batchDetails?.collabrixProductID}
            poNumber={batchDetails?.scheduleAgreementNumber}
            materialPlantID={batchDetails?.vendorPlant}
            materialStorageLocationID={batchDetails?.storageLocation}
            batchNumber={batchDetails?.vendorBatchNumber}
            vendorMosymphonyID={batchDetails?.vendorMosymphonyID}
            vendorPlantID={batchDetails?.vendorPlant}
            sponsorStorageLocation={batchDetails?.storageLocation}
          />

          {/* Allocation table */}
          <div style={{ marginTop: '1.5rem' }}>
            {allocationLoading ? (
              <div style={{ textAlign: 'center', padding: '2rem' }}>
                <CircularProgress />
              </div>
            ) : allocationError ? (
              <Typography color="error" style={{ padding: '1rem' }}>{allocationError}</Typography>
            ) : (
              <TableContainer component={Paper} style={{ border: '1px solid #ccc', borderRadius: '8px', overflow: 'auto', maxWidth: '100%' }}>
                <Table stickyHeader className="default-table-styles">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>BMS Material Code / Description</TableCell>
                      <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} align="right">Material BoM Qty.</TableCell>
                      <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>UOM</TableCell>
                      <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>BMS Material Batch Number</TableCell>
                      <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} align="right">Net Available Qty.</TableCell>
                      <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Expiry Date</TableCell>
                      <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', borderRight: '2px solid rgba(224, 224, 224, 1)' }} align="right">Planned Allocated Qty.</TableCell>
                      <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                        Planned Material Batch Number
                        <IconButton size="small" onClick={() => setInfoDialogOpen(true)} style={{ marginLeft: '4px', padding: '4px' }}>
                          <InfoOutlinedIcon style={{ fontSize: '18px', color: '#666' }} />
                        </IconButton>
                      </TableCell>
                      <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Country of Origin</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {allocationData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center">No allocation data found</TableCell>
                      </TableRow>
                    ) : allocationData.map((row, rowIdx) => {
                      const hasPlanned = row.plannedLotNumberAllocationDetails?.length > 0;
                      const lots = hasPlanned
                        ? row.plannedLotNumberAllocationDetails
                        : (row.actualConsumptionDetails?.length > 0
                            ? row.actualConsumptionDetails.map(c => ({
                                lotNumber: c.componentBatchNumber,
                                netAvailableQuantity: c.netAvailableQuantity,
                                expiryDate: c.expiryDate,
                                plannedAllocatedQuantity: 0,
                                plannedLotAllocation: null,
                                countryOfOrigin: null,
                                _fromActual: true,
                              }))
                            : [{}]);
                      return lots.map((lot, lotIdx) => {
                        const cellKey = `${rowIdx}-${lotIdx}`;
                        const canEdit =  batchDetails?.reviewAllocationForConsumptionReqd === true;
                        return (
                          <TableRow key={cellKey} style={{ backgroundColor: rowIdx % 2 === 0 ? '#fff' : '#fafafa' }}>
                            {lotIdx === 0 && (
                              <>
                                <TableCell rowSpan={lots.length}>
                                  {row.componentCode && row.componentName
                                    ? `${row.componentCode} / ${row.componentName}`
                                    : 'NA'}
                                </TableCell>
                                <TableCell rowSpan={lots.length} align="right">
                                  {row.componentQuantity != null ? Number(row.componentQuantity).toFixed(3) : 'NA'}
                                </TableCell>
                                <TableCell rowSpan={lots.length}>{row.uom || 'NA'}</TableCell>
                              </>
                            )}
                            <TableCell>{lot.lotNumber || 'NA'}</TableCell>
                            <TableCell align="right">
                              {lot.netAvailableQuantity != null ? Number(lot.netAvailableQuantity).toLocaleString() : 'NA'}
                            </TableCell>
                            <TableCell>
                              {lot.expiryDate ? moment(lot.expiryDate).format('DD-MMM-YYYY').toUpperCase() : 'NA'}
                            </TableCell>
                            <TableCell align="right" style={{ borderRight: '2px solid rgba(224, 224, 224, 1)' }}>
                              <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                {lot.plannedAllocatedQuantity != null ? lot.plannedAllocatedQuantity : 'NA'}
                                <IconButton
                                  size="small"
                                  onClick={() => handlePencilClick(row)}
                                  style={{ color: '#E65100', padding: '2px' }}
                                  className={classes.editIconButton}
                                  disabled={!canEdit}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </TableCell>
                            {lotIdx === 0 && (() => {
                              const poLineComponent = (poLineRes?.componentAllocationDataList || []).find(
                                c => c?.componentAllocationDetails?.componentCode === row.componentCode
                              );
                              return (
                                <>
                                  <TableCell rowSpan={lots.length}>
                                    {poLineComponent?.componentAllocationDetails?.plannedLotNumbers || 'NA'}
                                  </TableCell>
                                  <TableCell rowSpan={lots.length}>
                                    {poLineComponent?.componentAllocationDetails?.countryOfOrigin || 'NA'}
                                  </TableCell>
                                </>
                              );
                            })()}
                          </TableRow>
                        );
                      });
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>

          {/* Deplete Instruction Note */}
          {depleteInstructionComponents.length > 0 && (
            <div style={{
              marginTop: '1rem',
              padding: '0.75rem 1rem',
              border: '1px solid black',
              borderRadius: '4px',
              fontSize: '0.875rem',
            }}>
              <Typography variant="body2">
                Instruction - Deplete allocated batch(es) for BMS Material Code(s){' '}
                {depleteInstructionComponents.map((component, compIndex) => (
                  <span key={compIndex}>
                    {component.componentCode}
                    {component.batches.length > 0 && (
                      <span>
                        {' '}({component.batches.map((batch, batchIndex) => (
                          <span key={batchIndex}>
                            Batch {batch}{batchIndex < component.batches.length - 1 ? ', ' : ''}
                          </span>
                        ))})
                      </span>
                    )}
                    {compIndex < depleteInstructionComponents.length - 1 ? ', ' : ''}
                  </span>
                ))}
              </Typography>
            </div>
          )}

        </DialogContent>

        {/* Info Dialog for Planned Material Batch Number */}
        <Dialog open={infoDialogOpen} onClose={() => setInfoDialogOpen(false)} maxWidth="xs" fullWidth>
          <DialogContent style={{ padding: '24px' }}>
            <Grid container justifyContent="flex-end">
              <Typography
                variant="body2"
                style={{ fontSize: '1rem', fontWeight: 600, display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                onClick={() => setInfoDialogOpen(false)}
              >
                Close <CloseIcon fontSize="large" style={{ color: '#FF0000' }} />
              </Typography>
            </Grid>
            <Grid container direction="column" alignItems="center" style={{ marginTop: '16px' }}>
              <Typography variant="h6" style={{ fontWeight: 600, marginBottom: '20px' }}>
                Planned Material Batch Number
              </Typography>
              <Typography variant="body2" style={{ textAlign: 'center', lineHeight: '1.6' }}>
                Please use this field is to enter Material Batch Number
                <br /> that is not yet present in the inventory. In case of multiple
                <br /> Batch Number entry, use comma to separate the values.
              </Typography>
            </Grid>
          </DialogContent>
        </Dialog>

        {/* Edit allocation popup */}
        <Dialog open={editDialogOpen} maxWidth="md" fullWidth>
          {selectedRowForEdit && (
            <EditPlannedAllocatedQuantityDialog
              lotData={selectedRowForEdit}
              lotAllocationData={poLineRes?.componentAllocationDataList || []}
              lotAllocationRes={poLineRes}
              rmPmCode={selectedRowForEdit?.componentAllocationDetails?.componentCode}
              onClose={() => setEditDialogOpen(false)}
              poData={{
                scheduleLineDetails: {
                  scheduleAgreementNumber: batchDetails?.scheduleAgreementNumber,
                  sponsorName: batchDetails?.sponsorOrgName,
                  vendorName: batchDetails?.cmoMember,
                  vendorPlant: batchDetails?.vendorPlant,
                  storageLocation: batchDetails?.storageLocation,
                  schrockenSLID: batchDetails?.schrockenSLID,
                  vendorMosymphonyID: batchDetails?.vendorMosymphonyID,
                },
              }}
              schrockenSLID={batchDetails?.schrockenSLID}
              vendorMosymphonyID={batchDetails?.vendorMosymphonyID}
              handleClose={async (type) => {
                setEditDialogOpen(false);
                if (type === 'success') {
                  await fetchAllocationData();
                  setComponentAllocationSuccess(true);
                }
              }}
            />
          )}
        </Dialog>

        {/* Consumption details updated successfully */}
        <Dialog open={consumptionUpdateSuccess} fullWidth maxWidth="sm" PaperProps={{ style: { borderRadius: '16px' } }}>
          <DialogContent style={{ padding: '3.5rem 4rem', textAlign: 'center' }}>
            <CheckCircleIcon style={{ fontSize: '6rem', color: '#39811D', marginTop: '0.5rem' }} />
            <Typography variant="h5" style={{ fontWeight: 700, fontSize: '1.8rem', marginTop: '1.5rem', lineHeight: 1.3 }}>
              Consumption details updated successfully
            </Typography>
            <div style={{ marginTop: '2rem' }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: '#E65100',
                  color: '#fff',
                  textTransform: 'none',
                  borderRadius: '2rem',
                  padding: '0.6rem 3rem',
                  fontSize: '1rem',
                  boxShadow: 'none',
                }}
                onClick={() => {
                  setConsumptionUpdateSuccess(false);
                  fetchAllocationData();
                }}
              >
                OK
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        {/* Component allocation updated successfully */}
        <Dialog open={componentAllocationSuccess} fullWidth maxWidth="sm" PaperProps={{ style: { borderRadius: '16px' } }}>
          <DialogContent style={{ padding: '3.5rem 4rem', textAlign: 'center' }}>
            <CheckCircleIcon style={{ fontSize: '6rem', color: '#39811D', marginTop: '0.5rem' }} />
            <Typography variant="h5" style={{ fontWeight: 700, fontSize: '1.8rem', marginTop: '1.5rem', lineHeight: 1.3 }}>
              Component allocation updated successfully
            </Typography>
            <div style={{ marginTop: '2rem' }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: '#E65100',
                  color: '#fff',
                  textTransform: 'none',
                  borderRadius: '2rem',
                  padding: '0.6rem 3rem',
                  fontSize: '1rem',
                  boxShadow: 'none',
                }}
                onClick={() => {
                  setComponentAllocationSuccess(false);
                  handleUpdateConsumption();
                }}
              >
                Continue to update consumption details
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </Dialog>
    </React.Fragment>
  );
};

export default ViewStructuredInformation;
